var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class APIError extends Error {
  constructor({
    url,
    message,
    stacktrace,
    response,
    responseBody,
    requestBody,
    statusCode,
    responseHeaders
  }) {
    super(message);
    __publicField(this, "url");
    __publicField(this, "statusCode");
    __publicField(this, "traceId");
    __publicField(this, "responseBody");
    __publicField(this, "requestBody");
    __publicField(this, "responseHeaders");
    this.url = url;
    this.stack = stacktrace;
    this.statusCode = statusCode || -999;
    this.traceId = (responseHeaders == null ? void 0 : responseHeaders.traceid) || "";
    this.responseBody = responseBody || "";
    this.requestBody = requestBody || null;
    this.responseHeaders = responseHeaders || null;
    if (response) {
      this.statusCode = (response == null ? void 0 : response.status) || -999;
      this.traceId = (response == null ? void 0 : response.headers.get("traceid")) || "";
    }
  }
}
const getQueryName = (operation) => {
  var _a, _b, _c;
  const operationDefinition = (_b = (_a = operation == null ? void 0 : operation.query) == null ? void 0 : _a.definitions) == null ? void 0 : _b.find(
    (def) => (def == null ? void 0 : def.kind) === "OperationDefinition"
  );
  return (_c = operationDefinition == null ? void 0 : operationDefinition.name) == null ? void 0 : _c.value;
};
export {
  APIError as A,
  getQueryName as g
};
//# sourceMappingURL=urqlUtils-Ee2nyHqz.js.map
